


































































































































































































































































































































































import {
  faBars,
  faBuilding,
  faCaretRight,
  faEnvelope,
  faMoon,
  faParking,
  faPlus,
  faSearch,
  faSignInAlt,
  faSun,
  faUser
} from '@fortawesome/free-solid-svg-icons'
import { mapActions, mapGetters, mapState } from 'vuex'
import LinkDropdown from '~/components/car/header/LinkDropdown/LinkDropdown.vue'
import {
  HeaderDropdown,
  HeaderDropdownId,
  HeaderDropdownLinkClickEvent
} from '~/models/header/header-dropdown'
import HeaderDropdownService from '~/services/header/HeaderDropdownService'
import { USER_NS } from '~/store/modules/shared/user/state'
import { I18N_NS } from '~/store/modules/shared/i18n/state'
import { I18nLocale } from '~/models/shared/types'
import { faBuilding as farBuilding } from '@fortawesome/free-regular-svg-icons/faBuilding'
import { ADMINUSER_NS } from '~/store/modules/shared/admin/user/state'
import { USER_AGENT_NS } from '~/store/modules/shared/userAgent/state'
import Logo from '~/components/car/header/Logo.vue'
import { formatNumber } from '~/utils/number'
import { PARKING_NS } from '~/store/modules/shared/parking/state'
import LanguageSwitcher from '~/services/LanguageSwitcher'
import CImg from '~/components/shared/configurable/image/CImg.vue'
import { defineComponent } from '@nuxtjs/composition-api'
import CExternalLinkMediatorModal from '~/components/shared/configurable/modal/CExternalLinkMediatorModal.vue'
import { LegacyUrlService } from '~/services/legacy/url/LegacyUrlService'
import { mapDeps } from '~/plugins/dependency-container/utils'
import OfferButtonMobile from '~/components/car/header/OfferButtonMobile.vue'
import { ciFolderOpen } from '~/icons/source/regular/folder-open'
import { ciEnvelope } from '~/icons/source/regular/envelope'
import { ciAngleDownLight } from '~/icons/source/solid/angle-down-light'
import {
  faMoon as farMoon,
  faSun as farSun
} from '@fortawesome/free-regular-svg-icons'
import ThemeService from '~/services/theme/ThemeService'
import { THEME_NS } from '~/store/modules/shared/theme/state'
import { ciUserPlus } from '~/icons/source/solid/user-plus'
import { ciSearchbarMagnifier } from '~/icons/source/regular/searchbar-magnifier'
import { ciChartLine } from '~/icons/source/regular/chart-line'
import { ciUser } from '~/icons/source/regular/user'
import RouteGuardService from '~/services/RouteGuardService'
import CAnonGuardNewClassifiedModal from '~/components/shared/configurable/user/CAnonGuardNewClassifiedModal.vue'
import { ANON_GUARD_COOKIE } from '~/constants/anon-guard'

// NOTE: base api here -> https://www.car.gr/api/user/base-page/ user_base_page
// TODOs:
// - Parking and message notifications test with mock data

export default defineComponent({
  components: {
    CAnonGuardNewClassifiedModal,
    OfferButtonMobile,
    CExternalLinkMediatorModal,
    Logo,
    LinkDropdown,
    MyClassifiedsSubmenu: () =>
      import('~/components/car/header/MyClassifiedsSubmenu.vue'),
    AdminTopBar: () => import('~/components/shared/header/AdminTopBar.vue'),
    CarMobileMenu: () => import('~/components/car/header/CarMobileMenu.vue'),
    CAvatar: () =>
      import('~/components/shared/configurable/image/avatar/CAvatar.vue'),
    UserDropdownContent: () =>
      import('~/components/car/header/UserDropdownContent.vue'),
    CImg
  },
  props: {
    availableLocales: {
      type: Array,
      required: true
    }
  },
  data(): {
    showMobileMenu: boolean
    hoverReset: boolean
    subMenusMap: Map<string, HeaderDropdown>
    shownDropdowns: Set<HeaderDropdownId>
    loadedDropdowns: Set<
      Pick<HeaderDropdownId, HeaderDropdownId.USER | HeaderDropdownId.USER>
    >
    showExternalLinkMediatorModal: boolean
    externalLinkMediatorUrl: string
    hoveringThemeIcon: boolean
    anonGuardModalVisible: boolean
    anonGuardModalContinueUrl: string
  } {
    const rgservice = this.$dep(RouteGuardService)
    const subMenusMap = new Map([
      [
        'search',
        {
          title: this.$t('search'),
          links: []
        }
      ],
      [
        'offer',
        {
          title: this.$t('offer'),
          links: [],
          hide: !rgservice.userCanCreateClassified()
        }
      ],
      [
        'dealers',
        {
          title: this.$t('dealers'),
          links: []
        }
      ],
      [
        'information',
        {
          title: this.$t('information'),
          links: []
        }
      ]
    ])
    return {
      showMobileMenu: false,
      hoverReset: false,
      shownDropdowns: new Set(),
      loadedDropdowns: new Set(),
      subMenusMap,
      showExternalLinkMediatorModal: false,
      externalLinkMediatorUrl: '',
      hoveringThemeIcon: false,
      anonGuardModalVisible: false,
      anonGuardModalContinueUrl: ''
    }
  },
  computed: {
    headerDropdownId: () => HeaderDropdownId,
    ...mapGetters(USER_AGENT_NS, ['isPc', 'isMobile', 'isTablet']),
    ...mapState(USER_NS, {
      userType: 'type',
      myClassifieds: 'myClassifieds',
      username: 'name',
      avatar: 'avatar',
      unreadMessages: 'unreadMessages',
      unreadParkingNotifications: 'unreadParkingNotifications',
      unreadNotifications: 'unreadNotifications',
      rogueClassifiedsCount: 'rogueClassifiedsCount'
    }),
    ...mapGetters(USER_NS, {
      isDealer: 'isOfTypeDealer',
      isAdmin: 'isAdmin',
      isGuest: 'isGuest',
      isAnon: 'isSingleOrAnon',
      isSingle: 'isSingle',
      totalCredits: 'totalCredits',
      isAuditsUser: 'isAuditsUser'
    }),
    ...mapState(ADMINUSER_NS, {
      adminExtras: 'adminExtras'
    }),
    ...mapGetters(PARKING_NS, {
      showParking: 'getShowParking'
    }),
    ...mapGetters(I18N_NS, {
      locale: 'locale'
    }),
    ...mapGetters(THEME_NS, {
      themeIsLight: 'themeIsLight'
    }),
    ...mapDeps({
      languageSwitcher: LanguageSwitcher,
      legacyUrlService: LegacyUrlService,
      themeService: ThemeService,
      routeGuardService: RouteGuardService
    }),
    icons() {
      return {
        angleDown: ciAngleDownLight,
        plus: faPlus,
        signIn: faSignInAlt,
        user: faUser,
        building: faBuilding,
        parking: faParking,
        envelopeSolid: faEnvelope,
        envelopeLight: ciEnvelope,
        folder: ciFolderOpen,
        buildingRegular: farBuilding,
        caretRight: faCaretRight,
        bars: faBars,
        search: faSearch,
        register: ciUserPlus
      }
    },
    themeIcon() {
      if (this.themeIsLight) {
        if (this.hoveringThemeIcon) {
          return faMoon
        }
        return farMoon
      }
      if (this.hoveringThemeIcon) {
        return faSun
      }
      return farSun
    },
    localeCodeToFlag: () =>
      new Map([
        [I18nLocale.EN, require('~/assets/img/flags/en.png')],
        [I18nLocale.EL, require('~/assets/img/flags/el.png')]
      ]),
    accountUrl() {
      if (this.isDealer || this.isGuest) {
        return this.$router.resolve({ name: '__account' }).href
      }

      return null
    },
    totalCreditsFormatted() {
      return formatNumber(this.totalCredits)
    },
    messagesUrl() {
      return this.$router.resolve({ name: '__account_messages' }).href
    },
    messagesAtMaxCount() {
      return this.unreadMessages && this.unreadMessages > 99
    },
    userRegisterLink() {
      return this.legacyUrlService.getRegisterUrl({ 'from-header': 1 })
    },
    hasAccessToParking() {
      return this.routeGuardService.userHasAccessToParking()
    },
    hasAccessToMessages() {
      return this.routeGuardService.userCanReceiveMessages()
    }
  },
  created() {
    this.populateSubMenus()
  },
  mounted() {
    this.$dep(HeaderDropdownService).createElementDropdownEventListeners(this)
  },
  methods: {
    ...mapActions(PARKING_NS, {
      showParkingModal: 'show_parking',
      hideParkingModal: 'hide_parking'
    }),
    async populateSubMenus() {
      const map = new Map(this.subMenusMap)
      map
        .set('search', {
          ...this.subMenusMap.get('search'),
          ...{
            links: [
              {
                title: this.$t('cars::vehicles'),
                icon: await import('~/icons/source/duotone/car').then(m => {
                  return m.ciCar
                }),
                url: '/quick-search/vehicles/cars',
                useNuxtLink: false
              },
              {
                title: this.$t('bikes::vehicles'),
                icon: await import('~/icons/source/duotone/motorcycle').then(
                  m => {
                    return m.ciMotorcycle
                  }
                ),
                url: '/quick-search/vehicles/bikes',
                useNuxtLink: false
              },
              {
                title: this.$t('boats::vehicles'),
                icon: await import('~/icons/source/duotone/boat').then(m => {
                  return m.ciBoat
                }),
                url: '/quick-search/vehicles/boats',
                useNuxtLink: false
              },
              {
                title: this.$t('commercials::vehicles'),
                icon: await import('~/icons/source/duotone/truck').then(m => {
                  return m.ciTruck
                }),
                url: '/quick-search/vehicles/commercials',
                useNuxtLink: false
              },
              {
                title: this.$t('campers::vehicles'),
                icon: await import('~/icons/source/duotone/caravan').then(m => {
                  return m.ciCaravan
                }),
                url: '/quick-search/vehicles/campers',
                useNuxtLink: false
              },
              {
                title: this.$t('bicycles::vehicles'),
                icon: await import('~/icons/source/duotone/bicycle').then(m => {
                  return m.ciBicycle
                }),
                url: '/quick-search/vehicles/bicycles',
                useNuxtLink: false
              },
              {
                title: this.$t('hobby::vehicles'),
                icon: await import('~/icons/source/duotone/rc').then(m => {
                  return m.ciRc
                }),
                url: '/quick-search/vehicles/hobby',
                useNuxtLink: false
              },
              {
                title: this.$t('parts') + ' & ' + this.$t('accessories'),
                icon: await import(
                  '~/icons/source/duotone/parts-accessories'
                ).then(m => {
                  return m.ciPartsAccessories
                }),
                extra_classes: 'parts-link',
                iconClasses: 'tw-scale-[1.2]',
                url: '/quick-search/parts/for-cars',
                useNuxtLink: false
              },
              {
                title: this.$t('real estate') + ' - Plot.gr',
                icon: await import('~/icons/source/duotone/real-estate').then(
                  m => {
                    return m.ciRealEstate
                  }
                ),
                extra_classes: 'plot-link',
                iconClasses: 'tw-scale-[1.2]',
                url: '/quick-search/plot ',
                new_label: false,
                useNuxtLink: false
              },
              {
                title: this.$t('classifieds::xyma'),
                icon: await import('~/icons/source/duotone/xyma').then(
                  m => m.ciXyma
                ),
                extra_classes: 'xyma-link',
                iconClasses: 'tw-scale-[1.2]',
                url: '/quick-search/xyma',
                useNuxtLink: false
              },
              {
                title: this.$t('jobs'),
                icon: await import('~/icons/source/duotone/jobs').then(m => {
                  return m.ciJobs
                }),
                extra_classes: 'jobs-link',
                iconClasses: 'tw-scale-[1.2]',
                url: '/jobs/',
                new_label: false,
                useNuxtLink: true
              },
              {
                title: this.$t('rentals'),
                icon: await import('~/icons/source/brand/vehicle-rentals').then(
                  m => {
                    return m.ciVehicleRentals
                  }
                ),
                extra_classes: 'rentals-link',
                iconClasses: 'tw-scale-[1.2]',
                url: '/quick-search/rentals',
                new_label: true,
                useNuxtLink: false
              },
              {
                title: this.$t('deals'),
                icon: await import('~/icons/source/duotone/deals').then(m => {
                  return m.ciDeals
                }),
                iconClasses: 'tw-scale-[1.2]',
                url: '/deals/',
                useNuxtLink: true
              },
              {
                title: this.$t('questions and answers'),
                icon: await import('~/icons/source/brand/qna').then(m => {
                  return m.ciQna
                }),
                new_label: false,
                extra_classes: 'qna-link',
                url: '/questions/',
                useNuxtLink: true
              },
              {
                title: this.$t('used car prices'),
                icon: ciChartLine,
                extra_classes: 'used-link ci-fa',
                url: '/classifieds/cars/prices/',
                useNuxtLink: false
              },
              {
                title: this.$t('search classified with id'),
                icon: ciSearchbarMagnifier,
                url: '/information/search-classified/',
                extra_classes: 'ci-fa',
                useNuxtLink: false
              }
            ]
          }
        })
        .set('offer', {
          ...this.subMenusMap.get('offer'),
          ...{
            links: [
              {
                title: this.$t('car::vehicles'),
                icon: await import('~/icons/source/duotone/car').then(m => {
                  return m.ciCar
                }),
                url: '/classifieds/cars/new/',
                useNuxtLink: false,
                useAnonGuard: true
              },
              {
                title: this.$t('bike::vehicles'),
                icon: await import('~/icons/source/duotone/motorcycle').then(
                  m => {
                    return m.ciMotorcycle
                  }
                ),
                url: '/classifieds/bikes/new/',
                useNuxtLink: false,
                useAnonGuard: true
              },
              {
                title: this.$t('commercial::vehicles'),
                icon: await import('~/icons/source/duotone/truck').then(m => {
                  return m.ciTruck
                }),
                url: '/classifieds/commercial/new/',
                useNuxtLink: false,
                useAnonGuard: true
              },
              {
                title: this.$t('camper::vehicles'),
                icon: await import('~/icons/source/duotone/caravan').then(m => {
                  return m.ciCaravan
                }),
                url: '/classifieds/camper/new/',
                useNuxtLink: false,
                useAnonGuard: true
              },
              {
                title: this.$t('boat::vehicles'),
                icon: await import('~/icons/source/duotone/boat').then(m => {
                  return m.ciBoat
                }),
                url: '/classifieds/boats/new/',
                useNuxtLink: false,
                useAnonGuard: true
              },
              {
                title: this.$t('bicycle::vehicles'),
                icon: await import('~/icons/source/duotone/bicycle').then(m => {
                  return m.ciBicycle
                }),
                url: '/classifieds/bicycles/new/',
                useNuxtLink: false,
                useAnonGuard: true
              },
              {
                title: this.$t('hobby::vehicles'),
                icon: await import('~/icons/source/duotone/rc').then(m => {
                  return m.ciRc
                }),
                url: '/classifieds/hobby/new/',
                useNuxtLink: false,
                useAnonGuard: true
              },
              {
                title: this.$t('part') + '/' + this.$t('accessory'),
                icon: await import(
                  '~/icons/source/duotone/parts-accessories'
                ).then(m => {
                  return m.ciPartsAccessories
                }),
                iconClasses: 'tw-scale-[1.2]',
                url: '/parts/new',
                useNuxtLink: false,
                useAnonGuard: true
              },
              {
                title: this.$t('rent'),
                icon: await import('~/icons/source/brand/vehicle-rentals').then(
                  m => {
                    return m.ciVehicleRentals
                  }
                ),
                iconClasses: 'tw-scale-[1.2]',
                url: '/rentals/new/',
                new_label: true,
                useNuxtLink: true
              },
              {
                title: this.$t('real estate::akinito') + ' - Plot.gr',
                icon: await import('~/icons/source/duotone/real-estate').then(
                  m => {
                    return m.ciRealEstate
                  }
                ),
                extra_classes: 'plot-link',
                iconClasses: 'tw-scale-[1.2]',
                url: 'https://www.plot.gr/classifieds/new?vehuser=true',
                externalLink: true,
                useNuxtLink: false
              },
              {
                title: this.$t('classified::xyma'),
                icon: await import('~/icons/source/duotone/xyma').then(
                  m => m.ciXyma
                ),
                extra_classes: 'xyma-link',
                iconClasses: 'tw-scale-[1.2]',
                url: '/xyma/new/',
                useNuxtLink: false,
                useAnonGuard: true
              },
              {
                title: this.$t('job'),
                icon: await import('~/icons/source/duotone/jobs').then(m => {
                  return m.ciJobs
                }),
                extra_classes: 'jobs-link',
                iconClasses: 'tw-scale-[1.2]',
                url: '/jobs/new/',
                new_label: false,
                useNuxtLink: true
              },
              {
                title: this.$t('my classified'),
                icon: ciUser,
                hide: !this.isAnon,
                extra_classes: 'my-clsfd-link ci-fa',
                url: '/classifieds/edit/',
                useNuxtLink: false
              }
            ]
          }
        })
        .set('dealers', {
          ...this.subMenusMap.get('dealers'),
          ...{
            links: [
              {
                title: this.$t('on map'),
                url: '/dealers/map/',
                useNuxtLink: false
              },
              {
                title: this.$t('per prefecture'),
                url: '/dealers/',
                useNuxtLink: false
              },
              {
                title: this.$t('catalog of businesses'),
                url: '/cartalog/categories/',
                useNuxtLink: false
              },
              {
                title: this.$t('register'),
                hide: !this.isAnon,
                url: '/dealers/register/',
                useNuxtLink: false
              },
              {
                title: this.$t('login'),
                hide: !this.isAnon,
                url: '/login/',
                useNuxtLink: false
              }
            ]
          }
        })
        .set('information', {
          ...this.subMenusMap.get('information'),
          ...{
            links: [
              {
                title: this.$t('advertise in car.gr'),
                url: '/advertising/',
                new_label: true
              },
              {
                title: this.$t('contact'),
                url: '/information/contact/',
                useNuxtLink: false
              },
              {
                title: this.$t('dealer registration'),
                url: '/dealers/register/',
                useNuxtLink: false
              },
              {
                title: this.$t('user registration'),
                url: this.userRegisterLink,
                useNuxtLink: false
              },
              {
                title: this.$t('register your business'),
                url: '/cartalog/register/',
                useNuxtLink: false
              },
              {
                title: this.$t('users frequently asked questions'),
                url: '/information/users_faq/',
                useNuxtLink: false
              },
              {
                title: this.$t('dealers frequently asked questions'),
                url: '/information/dealers_faq/',
                useNuxtLink: false
              },
              {
                title: this.$t('subscription renewal'),
                url: '/information/renew/',
                useNuxtLink: false
              },
              {
                title: this.$t('learn about trades'),
                url: '/landing/trades/',
                useNuxtLink: false
              },
              {
                title: this.$t('used car prices'),
                url: '/classifieds/cars/prices/',
                useNuxtLink: false
              },
              {
                title: this.$t('market guide'),
                url: '/information/simboulos/',
                useNuxtLink: false
              },
              {
                title: this.$t('finance'),
                url: '/landing/tbi'
              },
              {
                title: this.$t('privacy policy'),
                url: '/information/privacy/',
                useNuxtLink: false
              },
              {
                title: 'Blog - Car.gr',
                url: 'https://blog.car.gr/'
              }
            ]
          }
        })
      this.subMenusMap = map
    },
    parkingClicked(e) {
      if (this.isPc) {
        e.preventDefault() // prevent link click

        if (
          this.$route.name &&
          (this.$route.name.startsWith('__parking') ||
            this.$route.name.startsWith('__account_parking'))
        ) {
          // already in parking full page
          return
        }

        if (this.hasAccessToParking) {
          if (this.showParking) {
            this.hideParkingModal()
          } else {
            this.showParkingModal()
          }
        }
      }
    },
    triggerMenuClose() {
      if (this.$refs.mobilemenu) {
        this.$refs.mobilemenu.closeMenu()
      }
    },
    linkClicked(dropdownLink: HeaderDropdownLinkClickEvent) {
      const { link, event } = dropdownLink

      if (link?.url) {
        this.$analytics.recordEvent({
          namespace: 'n_header_link_desktop',
          label: link.url,
          action: 'click'
        })
      }

      if (link?.externalLink && event) {
        event.preventDefault()
        // this is an external link so show the modal
        this.externalLinkMediatorUrl = link.url
        this.showExternalLinkMediatorModal = true
      }
      if (link && link.useNuxtLink) {
        this.hoverReset = true
      }
      if (
        link &&
        link.useAnonGuard &&
        this.isAnon &&
        !this.$cookies.get(ANON_GUARD_COOKIE)
      ) {
        event.preventDefault()
        this.anonGuardModalContinueUrl = link.url
        this.anonGuardModalVisible = true
      }
    },
    nuxtLinkClicked(link: string) {
      this.hoverReset = true

      if (
        this.$router.resolve({ path: link }).route.name !== this.$route.name
      ) {
        return this.$router.push({
          path: link
        })
      }
    }
  }
})
